import {CLEAR_MIX_TOTAL_REPORTS, FETCH_MIX_TOTAL_REPORTS, LIST_MIX_TOTAL_REPORTS} from "./types";

const init = {
    isLoading: false,
    data: null,
    filter: {},
};

export default (state = init, {type, payload}) => {
    switch (type) {
        case FETCH_MIX_TOTAL_REPORTS:
            return {
                ...state,
                filter: payload,
                isLoading: true
            };
        case LIST_MIX_TOTAL_REPORTS:
            return {
                ...state,
                isLoading: false,
                ...payload
            };
        case CLEAR_MIX_TOTAL_REPORTS:
            return {
                ...init
            };
        default:
            return state;
    }
}